/**
 * @generated SignedSource<<a6740c5dc4fe2a450f155cc3797a1530>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type enhancedTextElementForm_EnhancedTextElementFragment$data = {
  readonly id: string;
  readonly readMore: string | null;
  readonly readMoreButtonText: string | null;
  readonly text: string;
  readonly title: string;
  readonly " $fragmentType": "enhancedTextElementForm_EnhancedTextElementFragment";
};
export type enhancedTextElementForm_EnhancedTextElementFragment$key = {
  readonly " $data"?: enhancedTextElementForm_EnhancedTextElementFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"enhancedTextElementForm_EnhancedTextElementFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "enhancedTextElementForm_EnhancedTextElementFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "text",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "readMore",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "readMoreButtonText",
      "storageKey": null
    }
  ],
  "type": "EnhancedTextElement",
  "abstractKey": null
};

(node as any).hash = "4ecda25c0cb444647ff15084df2ec70e";

export default node;
